import { Injectable } from "@angular/core";
import { CVApiService } from "src/app/reusables/services/cv-api.service";
import { ModuleManagerDateRangeInfo } from "../../../../shared/models/module-manager/module-manager-settings.models";

@Injectable({
    providedIn: "root",
})
export class MetricReviewService {
    constructor(
        private readonly cvApiService: CVApiService,
    ) { }

    public async getCustomMetricReviewData(
        moduleKey: string,
        isAutoRefresh = false,
        isFirstLoad = false,
        abort?: Promise<void>
    ): Promise<any> {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const queryParams = new URLSearchParams({
                isAutoRefresh: String(isAutoRefresh),
                isFirstLoad: String(isFirstLoad),
            });
            const url = `/api/v2/dashboards/modules/custommetricreview/${moduleKey}?${queryParams}`;
            const response = await this.cvApiService.get<any>(url, renderEndpoint, abort);

            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        } catch (error) {
            console.error("Failed getting custom metric review data", error);
            throw error;
        }
    }

    public async loadDataForExport(moduleKey: string, format: string, isCXOne: boolean): Promise<any> {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

        } catch (error) {
            console.error("Failed getting render endpoint");
            throw error;
        }

        const url = `/api/v2/dashboards/modules/custommetricreview/${moduleKey}/export?format=` +
            format + "&isCXOne=" + isCXOne;
        try {
            const response = await this.cvApiService.get<any>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response;
            } else {
                throw response;
            }
        } catch (error) {
            console.error("Failed getting custom metric review data for export.");
            throw error;
        }
    }

    public async getAvailableDateRanges(moduleKey: string): Promise<ModuleManagerDateRangeInfo[]> {
        const url = `/api/v2/dashboards/modules/custommetricreview/${moduleKey}/availabledateranges`;
        try {
            const response = await this.cvApiService.get<ModuleManagerDateRangeInfo[]>(url);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        }
        catch (error) {
            console.error("Failed getting available date ranges.", error);
            throw error;
        }
    }
}
